import type { MentionData } from "./Mention";
import { resolveMentionType } from "./mentionUtils";

export const PROFILE_MENTION_EVENT = "profile_mention";

export type ProfileMentionEventDetail = {
	type: typeof PROFILE_MENTION_EVENT;
	content: {
		is_open: boolean;
		mention: MentionData;
	};
};

export function dispatchProfileMentionPanel(mention: MentionData) {
	const mentionType = resolveMentionType(mention);
	const detail: ProfileMentionEventDetail = {
		type: PROFILE_MENTION_EVENT,
		content: {
			is_open: true,
			mention: mentionType ? { ...mention, mention_type: mentionType } : mention,
		},
	};
	document.dispatchEvent(new CustomEvent("chatevent", { detail }));
}
